import "./Footer.css";

const Footer = () => {
  return (
    <footer>
      <p>© {new Date().getFullYear()} GC Receipts</p>{" "}
    </footer>
  );
};

export default Footer;
